import { motion } from "framer-motion";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

const MYTHS = [
  {
    n: "01",
    myth: "\u201CI need a clinical background to own an agency.\u201D",
    truth:
      "You don't. You need the right people around you — leadership is the skill that matters most.",
  },
  {
    n: "02",
    myth: "\u201CMedicare is the only way to make money.\u201D",
    truth:
      "There are 3 distinct payer doors — and Medicare is actually the slowest to access.",
  },
  {
    n: "03",
    myth: "\u201CI need everything figured out before I start.\u201D",
    truth: "Sequence is the goal, not perfection. Take the next right step.",
  },
];

export const Manifesto = () => (
  <section
    id="manifesto"
    data-testid="manifesto-section"
    className="relative bg-ink py-20 md:py-32"
  >
    <div className="container-tasha">
      <motion.div
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="max-w-3xl"
      >
        <span className="overline">The Truth</span>
        <h2 className="mt-5 font-serif text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
          Why most people stay <span className="font-script text-gold">stuck</span>
        </h2>
        <p className="mt-6 font-sans text-lg font-light text-cream/70">
          Three misconceptions keep aspiring agency owners in research mode for
          years. Let's clear them — right now.
        </p>
      </motion.div>

      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className="mt-16 grid gap-6 md:grid-cols-3"
      >
        {MYTHS.map((m) => (
          <motion.article
            key={m.n}
            variants={fadeUp}
            whileHover={{ y: -6 }}
            data-testid={`manifesto-card-${m.n}`}
            className="card-luxe group flex flex-col p-8 hover:border-gold/40"
          >
            <span className="gold-text-gradient font-serif text-7xl font-semibold leading-none md:text-8xl">
              {m.n}
            </span>
            <p className="mt-6 font-serif text-2xl italic leading-snug text-cream">
              {m.myth}
            </p>
            <div className="my-5 h-px w-full bg-cream/10 transition-colors group-hover:bg-gold/30" />
            <p className="font-sans text-base font-light leading-relaxed text-cream/70">
              {m.truth}
            </p>
          </motion.article>
        ))}
      </motion.div>
    </div>
  </section>
);

export default Manifesto;
